var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "vue-content-loading",
    { attrs: { height: 200, preserveAspectRatio: "none" } },
    [
      _c("rect", {
        attrs: { x: "0", y: "0", rx: "4", ry: "4", width: "390", height: "25" }
      }),
      _vm._v(" "),
      _c("rect", {
        attrs: { x: "0", y: "30", rx: "4", ry: "4", width: "390", height: "25" }
      }),
      _vm._v(" "),
      _c("rect", {
        attrs: { x: "0", y: "60", rx: "4", ry: "4", width: "390", height: "25" }
      }),
      _vm._v(" "),
      _c("rect", {
        attrs: { x: "0", y: "90", rx: "4", ry: "4", width: "390", height: "25" }
      }),
      _vm._v(" "),
      _c("rect", {
        attrs: {
          x: "0",
          y: "120",
          rx: "4",
          ry: "4",
          width: "390",
          height: "25"
        }
      }),
      _vm._v(" "),
      _c("rect", {
        attrs: {
          x: "0",
          y: "150",
          rx: "4",
          ry: "4",
          width: "390",
          height: "25"
        }
      }),
      _vm._v(" "),
      _c("rect", {
        attrs: {
          x: "0",
          y: "180",
          rx: "4",
          ry: "4",
          width: "390",
          height: "25"
        }
      })
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-a237bf4e", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-a237bf4e","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/homebase/campaigns/VideoLoadingSkeleton.vue
// module id = null
// module chunks = 